import { Typography } from "@mui/material";
import { BsExclamation } from "react-icons/bs";
import { StyledContainer,ContentWrapper } from "./NotFound.style";

export default function NotFound(props) {
  return (
    <StyledContainer>
      <ContentWrapper >
        <Typography> {props.title}</Typography>
        <BsExclamation size={42} />
      </ContentWrapper>
    </StyledContainer>
  );
}
